/*
 * $Id:: store.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import 'regenerator-runtime/runtime';
import logger from 'redux-logger'; // We'll use redux-logger just as an example of adding another middleware
import createSagaMiddleware from 'redux-saga';

import rootReducer from './rootReducer';
import rootSaga from './saga';

const sagaMiddleware = createSagaMiddleware();
const middleware = [
    ...getDefaultMiddleware({
        serializableCheck: false,
    }),
    sagaMiddleware,
    logger,
];

const myStore = () => {
    const store = configureStore({
        reducer: rootReducer,
        middleware,
    });
    sagaMiddleware.run(rootSaga);
    return store;
};

export default myStore();
